/**
 * @generated SignedSource<<40aaee1f07cddb25276ae65efa98c22c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AskCopilotMessageRating = "NEGATIVE" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type AskFellowPanelInner_RatingButtons_message$data = {
  readonly id: string;
  readonly userRating: AskCopilotMessageRating | null;
  readonly " $fragmentType": "AskFellowPanelInner_RatingButtons_message";
};
export type AskFellowPanelInner_RatingButtons_message$key = {
  readonly " $data"?: AskFellowPanelInner_RatingButtons_message$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_RatingButtons_message">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowPanelInner_RatingButtons_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userRating",
      "storageKey": null
    }
  ],
  "type": "AskCopilotMessage",
  "abstractKey": null
};

(node as any).hash = "370eb3e501dde302e1a51cf9fe87fa9d";

export default node;
